export const PLAYLIST_VIDEOS = [
  {
    "id": "AZ3v285rLYA",
    "title": "@Asha_Studios #explore #shorts #musicstudio #pune #viral",
    "duration": "0:56",
    "thumbnail": "https://i.ytimg.com/vi/AZ3v285rLYA/mqdefault.jpg"
  },
  {
    "id": "JnXoEOmwDWA",
    "title": "@Asha_Studios #explore #ad #music #recording #pune #trending",
    "duration": "0:56",
    "thumbnail": "https://i.ytimg.com/vi/JnXoEOmwDWA/mqdefault.jpg"
  },
  {
    "id": "rvW6eisdIyI",
    "title": "@Asha_Studios  #shorts #VIRAL #explore #music",
    "duration": "0:53",
    "thumbnail": "https://i.ytimg.com/vi/rvW6eisdIyI/mqdefault.jpg"
  },
  {
    "id": "2fzC4d3f7ks",
    "title": "Mere Rashke Qamar @Asha_Studios #explore #music #musicproduction #trending",
    "duration": "1:30",
    "thumbnail": "https://i.ytimg.com/vi/2fzC4d3f7ks/mqdefault.jpg"
  },
  {
    "id": "u-Gotk62YSQ",
    "title": "\"Karpoor Gauram Karunavataram” @Asha_Studios #music #mahashivratri #viral #mahadev #explore",
    "duration": "2:11",
    "thumbnail": "https://i.ytimg.com/vi/u-Gotk62YSQ/mqdefault.jpg"
  },
  {
    "id": "dVlEPrk_GrA",
    "title": "Kantara Song Cover | Studio Version | Asha Studios Pune 🎙️🔥 #music #kantra #coversong #explore",
    "duration": "1:15",
    "thumbnail": "https://i.ytimg.com/vi/dVlEPrk_GrA/mqdefault.jpg"
  },
  {
    "id": "kJzHKPhlcqU",
    "title": "Kantara Song Cover | Studio Version | Asha Studios Pune 🎙️🔥 #music #kantra #coversong #explore",
    "duration": "0:36",
    "thumbnail": "https://i.ytimg.com/vi/kJzHKPhlcqU/mqdefault.jpg"
  },
  {
    "id": "gXgE1RbJ1OM",
    "title": "Ek Hasina Thi–Short Studio Cover 🎙️| Old Bollywood Classic | Asha Studios #music #oldbollywoodsongs",
    "duration": "0:27",
    "thumbnail": "https://i.ytimg.com/vi/gXgE1RbJ1OM/mqdefault.jpg"
  },
  {
    "id": "PRMsVWA3sJQ",
    "title": "Before & After Studio Mix🎙️| Short Cover Part 2| Asha Studios Pune #oldbollywoodsongs #music #viral",
    "duration": "0:36",
    "thumbnail": "https://i.ytimg.com/vi/PRMsVWA3sJQ/mqdefault.jpg"
  },
  {
    "id": "Xf1oSvim6A4",
    "title": "New Recording Studio in Urulikanchan Pune 🎧 | Asha Studios Grand Opening #musicproduction #explore",
    "duration": "14:57",
    "thumbnail": "https://i.ytimg.com/vi/Xf1oSvim6A4/mqdefault.jpg"
  },
  {
    "id": "aSkLfoxBY9c",
    "title": "Balam Pichkari Keyboard Cover 🎹🔥 | Holi Special | Asha Studios #holi #music #musicproduction #viral",
    "duration": "1:33",
    "thumbnail": "https://i.ytimg.com/vi/aSkLfoxBY9c/mqdefault.jpg"
  },
  {
    "id": "jdDTHCDqMcw",
    "title": "Ganesh Mantra | Shree Ganeshay Namah |@Asha_Studios #shorts #bappa #musicproduction #explore",
    "duration": "0:54",
    "thumbnail": "https://i.ytimg.com/vi/jdDTHCDqMcw/mqdefault.jpg"
  },
  {
    "id": "5laBsRpwg2g",
    "title": "Yun Hi Chala Chal Cover 🎶| Studio Vibes | Must Watch! #YunHiChalaChal #Swades #BollywoodSong #music",
    "duration": "2:23",
    "thumbnail": "https://i.ytimg.com/vi/5laBsRpwg2g/mqdefault.jpg"
  },
  {
    "id": "SNj8gkhF1Os",
    "title": "The Final Countdown Begins… ⏳🔥@Asha_Studios #musicproduction #explore #shorts #trending #viral",
    "duration": "0:25",
    "thumbnail": "https://i.ytimg.com/vi/SNj8gkhF1Os/mqdefault.jpg"
  },
  {
    "id": "bnLDPPzd3TU",
    "title": "First Recording Session At Our Studio @Asha_Studios #music #musicproduction #shorts #viral",
    "duration": "0:20",
    "thumbnail": "https://i.ytimg.com/vi/bnLDPPzd3TU/mqdefault.jpg"
  }
];
